module.exports = __webpack_public_path__ + "6b048469baf5a325e5a6280e988216e6.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/desktop.png
// module id = 686
// module chunks = 0